'use strict';

var Backbone = require('backbone'),
  config = require('../../config'),

  ExpandingCarouselView = Backbone.View.extend({
    events: {
      'click .ExpandingCarousel-cta': 'toggle',
      'click .ExpandingCarousel-close': 'close'
    },

    initialize: function() {
      this.$carousel = this.$el.find('.ExpandingCarousel-carousel');
      this.$slides = this.$el.find('.ExpandingCarousel-slide');
      this.$ctas = this.$el.find('.ExpandingCarousel-cta');
      this.$panels = this.$el.find('.ExpandingCarousel-panel');
      if (this.$panels.filter('.' + config.classes.isActive).length) {
        this.$carousel.slick('slickSetOption', 'draggable', false);
        this.$carousel.slick('slickSetOption', 'swipe', false);
      }
    },

    toggle: function(e) {
      e.preventDefault();
      var index = this.$ctas.index(e.currentTarget);
      if (this.$slides.eq(index).hasClass(config.classes.isActive)) {
        this.close();
      }
      else {
        this.show(index);
      }
    },

    show: function(index) {
      this.close();
      this.$slides.eq(index).addClass(config.classes.isActive);
      this.$panels.eq(index).addClass(config.classes.isActive);
      this.$carousel.slick('goTo', index);
      this.$carousel.slick('slickSetOption', 'draggable', false);
      this.$carousel.slick('slickSetOption', 'swipe', false);
    },

    close: function(e) {
      if (e) {
        e.preventDefault();
      }

      this.$slides.removeClass(config.classes.isActive);
      this.$panels.removeClass(config.classes.isActive);
      this.$carousel.slick('slickSetOption', 'draggable', true);
      this.$carousel.slick('slickSetOption', 'swipe', true);
    }
  }, {
    create: function($parent) {
      $parent.find('.ExpandingCarousel').each(function(n, el) {
        new ExpandingCarouselView({
          el: el
        });
      });
    }
  });

module.exports = ExpandingCarouselView;



// WEBPACK FOOTER //
// ./assets/js/components/carousel/ExpandingCarouselView.js